<div class="container col-sm-8 pt-5 webview text-center"  [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt" *ngIf="!addAddressFlow">{{question}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt" *ngIf="addAddressFlow">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt" *ngIf="addAddressFlow">{{question_sub2}}</h1>
    <h1 class="text-center font-weight-normal-calibre questxt" *ngIf="addAddressFlow">{{question_sub3}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt" *ngIf="addAddressFlow">{{question_sub4}}</h1>
    <div class="col-sm-12">
        <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-right" for="NewService">
                    <img src="{{ns_src}}" height="100px">
                    <div></div>
                    <label for="NewService">New Service</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type='checkbox' class="custom-control-input" id="NewService" value='New Service'
                            [(ngModel)]="hgService.ns" name="service" (change)="getService($event)" />
                        <label class="custom-control-label" for="NewService"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-left" for="SwitchingProviders">
                    <img src="{{sp_src}}" height="100px">
                    <div></div>
                    <label for="SwitchingProviders">Switching Providers</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type='checkbox' class="custom-control-input" id="SwitchingProviders" value='Switching Providers'
                            [(ngModel)]="hgService.sp" name="service" (change)="getService($event)" />
                        <label class="custom-control-label" for="SwitchingProviders"></label>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': isChecked}" (click)="next();">Next</button>
</div>
<div class="container mobileview px-0 mb-4" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0 mt-5">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto" >
            <div class="arrow_box">
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
        <div class="d-flex mt-2">
            <div class="col-6 pl-0 box-shadow-none">
                <label class="card card-list text-center d-inline-block" for="NewService" style= "min-height: 156px;">
                    <img src="{{ns_src}}" width="60%">
                    <label for="NewService">New Service</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type='checkbox' class="custom-control-input" id="NewService_mob" value='New Service'
                            [(ngModel)]="hgService.ns" name="service" (change)="getService($event);"/>
                        <label class="custom-control-label" for="NewService"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 pr-0 box-shadow-none">
                <label class="card card-list text-center d-inline-block" for="SwitchingProviders" style= "min-height: 156px;">
                    <img src="{{sp_src}}" width="60%">
                    <label for="SwitchingProviders">Switching Providers</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type='checkbox' class="custom-control-input" id="SwitchingProviders_mob" value='Switching Providers'
                            [(ngModel)]="hgService.sp" name="service" (change)="getService($event);"/>
                        <label class="custom-control-label" for="SwitchingProviders"></label>
                    </div>
                </label>
            </div>
        </div>
        
        <!-- <div class="col-12">
    <div class="custom-control custom-checkbox chkbox mb-2">            
            <input type='checkbox' class="custom-control-input" id="SwitchingProviders3" value='Switching Providers'
                [(ngModel)]="hgService.sp" name="service" (change)="getService($event)" />                        
                <label class="custom-control-label"  for="SwitchingProviders3">Label text</label>                   
        </div>
    </div> -->
        <!-- <div class="form-group">
            <input type='checkbox' value='New Service' [(ngModel)]="hgService.ns" name="service" (change)="getService($event);" />New
            service
        </div>
        <div class="form-group">
            <input type='checkbox' value='Switching Providers' [(ngModel)]="hgService.sp" name="service" (change)="getService($event);" />Switching
            Providers
        </div> -->
        <div class="text-center" style="width:100% !important;"> <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p></div>
        <div style="width:97% !important; text-align: right;">
            <div *ngIf="user_bot" class="ash_box mt-2" >
                <h1 class="ansMob" *ngIf ="service === 'New Service'">I want to establish New Service</h1>
                <h1 class="ansMob" *ngIf ="service === 'Switching Providers'">I want to Switch Providers</h1>
            </div>
        </div>
        
    </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center">
        <span><img src="assets/images/active2.png"></span>
        <h5 class="clr333 processtxt">10% Completed</h5>
    </div>
</div> -->